import { renderFormula } from '../components/formBuilder/utility/calculateFields';
import FormUIOptions from '../components/formBuilder/formElements/formUIOptions';
import { isValue } from './isValue';

const formatDecimals = (value, decimalPlaces) => {
  // If decimal places aren't specified, return value as is
  if (decimalPlaces === undefined) return value;

  const float = parseFloat(`0.${value}`);
  const truncated = float.toFixed(decimalPlaces);
  const decimals = truncated.split('.')[1];
  return decimals;
};

export function getNumberWithCommas(value, decimalPlaces = 0) {
  if (value === null || value === undefined || value === 'N/A' || value === '')
    return '';

  if (isNaN(parseInt(value))) {
    return '';
  }

  let result = value?.toLocaleString('en-US', {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  });

  return result;
}

export function getNumberFromString(value) {
  if (typeof value === 'number') return value;
  if (typeof value === 'object') return value;

  if (!value || value === '') return null;

  let tempValue = value;

  // Remove unit if any
  if (typeof tempValue === 'string' && tempValue.includes('_')) {
    [tempValue] = tempValue.split('_');
  }

  // Remove commas if any
  const withoutCommas = tempValue.replace(/,/gi, '');

  // Convert string to number
  return Number(withoutCommas);
}

export const formatLargeNumber = (number, field) => {
  if (typeof number !== 'number') return null;

  let tempNumber = Math.abs(number);
  const isNegative = number < 0;

  let result;

  if (typeof tempNumber !== 'number') {
    tempNumber = parseInt(tempNumber);
  }

  if (typeof tempNumber !== 'number' || isNaN(tempNumber)) {
    return '';
  }

  if (tempNumber < 10 ** 4) {
    // under 10k
    result = getNumberWithCommas(tempNumber, field?.decimals || 0);
  } else if (tempNumber < 10 ** 6) {
    // 10k - 999k
    const thousands = Math.round(tempNumber / 10 ** 3);
    result = `${thousands}k`;
  } else if (tempNumber < 10 ** 9) {
    // 1M - 999M
    const millions = Math.round((tempNumber * 100) / 10 ** 6) / 100;
    result = `${millions}M`;
  } else {
    // 1B - infinity
    const billions = Math.round((tempNumber * 100) / 10 ** 9) / 100;
    result = `${billions}B`;
  }

  if (isNegative) {
    result = `-${result}`;
  }
  if (field?.type === FormUIOptions.Money) {
    result = `$${result}`.replace('$-', '-$');
  }

  return field?.formula ? renderFormula(field, result) : result;
};
